import { render, staticRenderFns } from "./BatchUserUploadToolUpdatePoints.vue?vue&type=template&id=53ebdc24&scoped=true&"
import script from "./BatchUserUploadToolUpdatePoints.vue?vue&type=script&lang=js&"
export * from "./BatchUserUploadToolUpdatePoints.vue?vue&type=script&lang=js&"
import style0 from "./BatchUserUploadToolUpdatePoints.vue?vue&type=style&index=0&id=53ebdc24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ebdc24",
  null
  
)

export default component.exports